import React from 'react'
import { Link } from 'react-router-dom';

interface FooterProps { }

const Footer: React.FC<FooterProps> = () => {
  return (
    <div>
      <footer className="footer mt-auto py-3 bg-white text-center">
        <div className="container">
          <span className="text-muted"> Copyright © <span id="year" className='me-1'> 2025 </span> 
            <Link to="#!" className="text-dark fw-medium">Udon</Link>. Designed with&nbsp;
            <span className="bi bi-heart-fill text-danger"></span> by
            <Link to="https://spruko.com/" target='_blank'> <span className="fw-medium text-primary text-decoration-underline">Spruko</span> </Link> All rights reserved
          </span>
        </div>
      </footer>
    </div>
  )
}

export default Footer;

